import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./follous.css"; // Import the custom CSS file

const FollowUs = () => {
  const instagramItems = [
    {
      link: "https://www.instagram.com/mrg_multisportsclub",
      imgSrc: "./assets/images/reviews/instagram.png",
      imgSrcSet:
        "./assets/images/reviews/instagram.png 500w, " +
        "./assets/images/reviews/instagram.png 800w, " +
        "./assets/images/reviews/instagram.png 939w",
      altText: "Follow us on Instagram - Image 1",
    },
    {
      link: "https://www.facebook.com/godara146?mibextid=2JQ9oc",
      imgSrc: "./assets/images/reviews/facebook.png",
      imgSrcSet:
        "./assets/images/reviews/facebook.png 500w, " +
        "./assets/images/reviews/facebook.png 800w, " +
        "./assets/images/reviews/facebook.png 939w",
      altText: "Follow us on Facebook - Image 2",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "20px", // Adds space between items in mobile view
        },
      },
    ],
  };

  return (
    <div className="wide-section baseline-right">
      <div className="mg_follow_main">
        <h2 className="header-middle mg_underheader">Follow Us</h2>
        <Slider {...settings} className="inst-slider">
          {instagramItems.map((item, index) => (
            <div key={index} className="slider-item">
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="insta-galery-item w-inline-block"
                style={{ borderRadius: "15px", overflow: "hidden" }}
              >
                <img
                  src={item.imgSrc}
                  srcSet={item.imgSrcSet}
                  sizes="(max-width: 479px) 49vw, 23vw"
                  alt={item.altText}
                  className="insta-galery-item-img"
                  style={{ borderRadius: "15px" }}
                />
                <div className="insta-galery-item-text">
                  @mrgmultisports club
                </div>
              </a>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default FollowUs;
